import { Variant } from './products';

export type QuoteAddress = {
  address?: string;
  postalCode?: string;
  postalAddress?: string;
};

export enum QuoteStatus {
  created = 'created',
  notSent = 'notSent',
  draft = 'draft',
  inReview = 'inReview',
  sent = 'sent',
  accepted = 'accepted',
  ordered = 'ordered',
  declined = 'declined',
}

export type QuoteProduct = {
  quoteItemId: number;
  articleNumber: string;
  quantity: number;
  markup?: number;
  salesDiscount?: number;
  netPrice: number;
  salesPrice: number;
  quoteNetPrice: number;
  quoteSalesPrice: number;
  articleName?: string;
};

export type QuoteVariant = QuoteProduct &
  Variant & {
    isSelected: boolean; // Only for frontend, handles the checkbox select
    discontinued?: boolean;
  };

export type QuoteCustomItem = {
  quoteCustomItemId: number;
  isSelected: boolean;
  customItemName?: string;
  quantity?: number;
  unit?: string;
  vatRate?: number;
  price?: number;
  isRot: boolean;
};

export type Quote = {
  quoteId?: number;
  status: QuoteStatus;
  sender: {
    name?: string;
    organizationNumber?: string;
    reference?: string;
    address: QuoteAddress;
  };
  receiver: {
    type: string;
    label?: string;
    name?: string;
    contactPerson?: string;
    address: QuoteAddress;
  };
  priceType: string;
  mergeArticles: boolean;
  showDiscounts: boolean;
  items: QuoteProduct[];
  customItems: QuoteCustomItem[];
  finalMessage?: string;
  validFrom?: string;
  validFor?: number;
};

export type QuoteResponseEntity = Quote & {
  updatedAt: Date;
  createdAt: Date;
  itemsCount: number;
  netPriceSum?: number;
  salesPriceSum?: number;
  quotePriceSum?: number;
};

export type QuoteContext = 'normal' | 'quote' | 'external' | string;

export type QuoteListItem = {
  isSelected: boolean; // Only for frontend, handles the checkbox select
  id: number;
  status: QuoteStatus;
  productCount: number;
  productSum: number;
  quoteProductSum: number;
  updatedAt: Date;
  receiverLabel?: string;
  contactPerson?: string;
};

export type QuoteListSortByValue = 'quoteId' | 'updatedAt' | 'customerName';

export type QuoteListQueryParams = {
  offset: number;
  limit: number;
  sortBy?: QuoteListSortByValue;
  sortOrder?: 'asc' | 'desc';
  search?: string;
  startDate?: string;
  endDate?: string;
  status?: 'draft' | 'accepted';
};

export const DEMO_QUOTE_LIST_ITEMS: QuoteListItem[] = [
  {
    isSelected: false,
    id: 1,
    status: QuoteStatus.inReview,
    productCount: 4,
    productSum: 14400,
    quoteProductSum: 20000,
    updatedAt: new Date(),
    receiverLabel: 'Company1',
    contactPerson: 'R. Swede',
  },
  {
    isSelected: false,
    id: 2,
    status: QuoteStatus.accepted,
    productCount: 10,
    productSum: 100,
    quoteProductSum: 1000000,
    updatedAt: new Date(2025, 1, 10),
    receiverLabel: 'Company2',
    contactPerson: 'C. Gowiński',
  },
  {
    isSelected: false,
    id: 5,
    status: QuoteStatus.declined,
    productCount: 10,
    productSum: 14400,
    quoteProductSum: 20000,
    updatedAt: new Date(2025, 3, 30),
    receiverLabel: 'Company3',
    contactPerson: 'R. Swede Igen',
  },
];
